<template lang="html">
  <transition name="fade" mode="out-in">
    <div id="fullscreen-menu" class="fixed-top w-100 h-100" v-show="showMenu">
      <div class="container-fluid">
        <div class="row">
          <div id="nav" class="position-absolute h-100
          d-flex flex-column align-items-start justify-content-center"
          :class="{ active: menuOpen }">
            <router-link to="/"
              @click.native="setMenuActive(false)"
              class="btn-floorplans link d-block d-md-inline-block">
              3d building & floorplans
            </router-link>
            <router-link to="/neighbourhood"
              @click.native="setMenuActive(false)"
              class="btn-neighbourhood link d-block d-md-inline-block"
              v-if="isTouchscreen">
              neighbourhood
            </router-link>
            <router-link to="/amenities"
              @click.native="setMenuActive(false)"
              class="btn-tour link d-block d-md-inline-block"
              v-if="isTouchscreen">
              amenities
            </router-link>
            <router-link to="/builder"
              @click.native="setMenuActive(false)"
              class="btn-tour link d-block d-md-inline-block"
              v-if="isTouchscreen">
              builder story
            </router-link>
            <!-- <router-link to="/video"
              @click.native="setMenuActive(false)"
              class="btn-tour link d-block d-md-inline-block"
              v-if="isTouchscreen">
              video
            </router-link> -->
            <div class="close-btn position-absolute" @click="setMenu(false)">
              <i class="fal fa-times-circle"></i>
            </div>
          </div>
          <div class="col-xl-12 col-md-12 col-12 main-content
          d-flex flex-column text-left justify-content-center"
          style="background-image: url(/static/img/landing/landing-bg-photo-3.jpg)"
          @click="setMenu(true)"
          :class="{ active: menuOpen, scrolling: bgScroll }">
            <div id="full-logo" class="nav-content mt-5">
              <img src="/static/img/landing/landing-logo.png" />
            </div>
            <div id="tagline" class="nav-content mt-5">
              A First.<br />
              For Living.
            </div>
            <div class="large-q position-absolute">
              <img src="/static/img/landing/landing-q-logo.png" />
            </div>
            <div class="nav-content discover d-flex flex-row align-items-center mt-5">
              <div class="explore-btn">
                Discover
              </div>
              <div class="explore-line inline-block"
              :class="{ active: lineScroll }"
              >

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      menuOpen: false,
      bgScroll: false,
      lineScroll: false,
      interval: null,
      lineInterval: null,
      idleCounter: 0,
      idleInterval: null
    };
  },
  computed: {
    ...mapState({
      forPublic: state => state.project.forPublic,
      userName: state => state.user.agent.name,
      menuActive: state => state.ui.menuActive,
      isTouchscreen: state => state.project.isTouchscreen
    }),
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    }),
    showMenu() {
      return this.menuActive;
    },
  },
  methods: {
    ...mapMutations({
      setMenuActive: 'ui/setMenuActive',
      setIdle: 'ui/setIdle'
    }),
    ...mapActions({
      clearToken: 'user/clearToken',
      clearFavourites: 'floorplans/clearFavourites'
    }),
    logout() {
      this.clearToken();
      this.$router.push('/login');
      this.$toasted.show('Logout successful.', {
        theme: 'success',
        position: 'top-center',
        duration: 3000,
        type: 'success'
      });
      this.setMenuActive(false);

    },
    setMenu(enabled) {
      if (!this.isTouchscreen) {
        this.setMenuActive(false);
      } else {
        this.menuOpen = enabled;
      }
    },
    toggleBgScroll() {
      this.bgScroll = !this.bgScroll;
    },
    toggleLineScroll() {
      this.lineScroll = !this.lineScroll;
    },
    initAnimations() {
      // this.bgScroll = true;
      // if (this.interval) {
      //   clearInterval(this.interval);
      // }
      // this.interval = setInterval(this.toggleBgScroll, 17000);

      this.lineScroll = true;
      if (this.lineInterval) {
        clearInterval(this.lineInterval);
      }
      this.lineInterval = setInterval(this.toggleLineScroll, 9000);
    },
    clearIdle() {
      this.idleCounter = 0;
      this.setIdle(false);
    },
    idleCheck() {
      this.idleCounter += 1;
      if (this.idleCounter > 8 * 6) {
        this.setMenuActive(true);
        this.setMenu(false);
        this.setIdle(true);

        this.clearFavourites();
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        setTimeout(() => {
          // this.setMenu(false);
        }, 300);
      }
    },
    menuActive: {
      immediate: false,
      handler() {
        if (this.menuActive && !this.isTouchscreen) {
          this.setMenuActive(false);
        } else if (this.menuActive && this.isTouchscreen) {
          setTimeout(() => {
            this.initAnimations();

            // this.setMenu(true);
          }, 100);
        } else {
          setTimeout(() => {
            this.bgScroll = false;
            this.lineScroll = false;
            clearInterval(this.interval);
          }, 300);
        }
      }
    }
  },
  created() {
    // if (this.$route.name === 'FloorplanList' && this.forPublic) {
    //   this.setMenuActive(true);
    // } else {
    //   this.setMenuActive(false);
    // }
    this.setMenuActive(true);

    this.initAnimations();

    window.addEventListener('click', this.clearIdle);
    this.idleInterval = setInterval(this.idleCheck, 10000);
  }
};
</script>

<style lang="scss" scoped>
$menuSize: 815px;

#fullscreen-menu {
  background: var(--branding);
  z-index: 2100;
  height: 100vh;

  font-family: Didot-Regular, serif;
}

#menu-render {
  height: 100vh;
  object-fit: cover;
  width: 100%;
}

@media screen and (max-width: $breakpoint-md) {
  #full-logo  {
    img {
      max-width: 100%;
    }
  }
}

#tagline {
  font-family: Didot-Regular;
  color: white;
  font-size: 80px;
  line-height: 90px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

@media screen and (max-width: $breakpoint-md) {
  #tagline {
    font-size: 2.5rem;
    letter-spacing: 2px;
    line-height: 1.5;
  }
}

.logout {
  margin-top: 4rem;
  margin-left: 1.6rem;
  font-family: Scandia-Regular, sans-serif;
  color: white;
}

#nav {
  // background-color: white;
  transform: translate3d(-100%, 0, 0);
  width: $menuSize;

  @media screen and (min-width: $breakpoint-md) {
    border: none;
  }

  &.active {
    transform: translate3d(0%, 0, 0);
  }

  .close-btn {
    color: white;
    bottom: 20px;
    left: 20px;
    i {
      font-size: 2rem;
    }
  }
}

.main-content {
  height: 100vh;
  transition: background-position 15s ease-in-out, transform 0.5s ease-out;
  transform: translate3d(calc(100% - 100vw), 0, 0);
  // background-position: -2286px 0px;

  &.active {
    transform: translate3d($menuSize, 0, 0);
  }

  &.scrolling {
    background-position: 0px 0px;
    transition: background-position 15s ease-in-out, transform 0.5s ease-out;
  }
}

.link {
  display: inline-block;
  // font-size: 1.4rem;
  text-transform: uppercase;
  margin: 2rem 3rem 2rem 3rem;
  color: white;

  font-family: Didot-Regular;
  font-size: 33px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 47px;

  @media screen and (min-width: $breakpoint-md) {
    font-size: 2rem;
    margin: 2rem 3rem 1rem 8rem;
  }

  .fa-angle-right {
    position: relative;
    left: -10px;
    transition: left 0.3s ease;
  }

  &:hover {
    color: white;

    .fa-angle-right {
      left: 0px;
    }
  }
}

.large-q {
  right: -35px;
  top: 50%;
  opacity: 0.8;
  transform: translate3d(0, -50%, 0);
}

@media screen and (max-width: $breakpoint-md) {
  .large-q {
    img {
      max-width: 100%;
    }
  }
}

.explore-btn {
  margin-top: 100px;
  // font-family: Scandia-Regular;
  display: inline-block;
  cursor: pointer;
  // border: 1px solid white;
  // background: rgba(255,255,255, 0.8);
  font-size: 2rem;
  color: white;
  width: auto;
}

.explore-line {
  margin-top: 100px;

  height: 2px;
  vertical-align: center;
  background-color: white;
  display: inline-block;

  transition: all 2s ease-out;
  width: 0px;
  margin-left: 20px;

  &.active {
    width: 150px;
  }
}

.nav-content {
  margin-left: 150px;
}

@media screen and (max-width: $breakpoint-md) {
  .nav-content {
    margin-left: auto;
    margin-right: auto;

    &.discover {
      margin-left: 5%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FullscreenMenu.vue